import { useCallback, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Typography, Alert } from '@mui/material';
import SettingsFrom from '../sections/@dashboard/settings/Form';
import { useAuthContext } from '../auth/useAuthContext';
import axios from '../utils/Axios';

export default function GlobalSettingsPage() {
  const { user, setGlobalUser } = useAuthContext();
  const [success, setSuccess] = useState(null);

  const updateUser = useCallback(async (userData) => {
    const response = await axios.put(`/user`, userData);
    setGlobalUser(response.data.user);
    setSuccess({
      bg: 'success',
      message: 'Settings Updated.',
    });
    setTimeout(() => setSuccess(null), 6000);
  }, []);

  return (
    <>
      <Helmet>
        <title>Global Settings | {localStorage.getItem("companyName") ?? "FlowBookings"}</title>
      </Helmet>
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Global Settings
        </Typography>
        {success != null && (
          <Alert severity={success.bg} color="info" sx={{ mt: 2, mb: 2 }}>
            {success.message}
          </Alert>
        )}
        <SettingsFrom config={user.config} updateUser={updateUser} />
      </Container>
    </>
  );
}
